/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
/**
* CSS Custom Properties
*
* These properties can be overridden using the component's tag as selector.
*
* @prop --calcite-alert-width: Specifies the width of the component.
* @prop --calcite-alert-background-color: Specifies the component's background color.
* @prop --calcite-alert-corner-radius: Specifies the component's corner radius.
* @prop --calcite-alert-shadow: Specifies the component's shadow.
*/
:host {
  --calcite-internal-alert-edge-distance: 2rem;
  display: block;
  inline-size: var(--calcite-alert-width);
}

.container {
  pointer-events: none;
  position: fixed;
  z-index: var(--calcite-z-index-toast);
  margin-inline: auto;
  margin-block: 0px;
  box-sizing: border-box;
  display: flex;
  inline-size: 100%;
  min-inline-size: min-content;
  align-items: center;
  justify-content: center;
  text-align: start;
  opacity: 0;
  --tw-shadow: 0 6px 20px -4px rgba(0, 0, 0, 0.1), 0 4px 12px -2px rgba(0, 0, 0, 0.08);
  --tw-shadow-colored: 0 6px 20px -4px var(--tw-shadow-color), 0 4px 12px -2px var(--tw-shadow-color);
  box-shadow: var(--calcite-alert-shadow, var(--tw-ring-offset-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-ring-shadow, 0 0 rgba(0, 0, 0, 0)), var(--tw-shadow));
  background-color: var(--calcite-alert-background-color, var(--calcite-color-foreground-1));
  border-radius: var(--calcite-alert-corner-radius, var(--calcite-border-radius));
  border-block-start: 0 solid transparent;
  border-inline: 1px solid var(--calcite-color-border-3);
  border-block-end: 1px solid var(--calcite-color-border-3);
  max-inline-size: calc(100% - var(--calcite-internal-alert-edge-distance) * 2);
  transition: opacity var(--calcite-internal-animation-timing-slow) cubic-bezier(0.215, 0.44, 0.42, 0.88), all var(--calcite-animation-timing) ease-in-out;
}
.container--bottom, .container--top {
  inset-inline-end: 0;
  inset-inline-start: 0;
}
.container[class*=bottom] {
  transform: translate3d(0, var(--calcite-internal-alert-edge-distance), 0);
  inset-block-end: var(--calcite-internal-alert-edge-distance);
}
.container[class*=top] {
  transform: translate3d(0, calc(-1 * var(--calcite-internal-alert-edge-distance)), 0);
  inset-block-start: var(--calcite-internal-alert-edge-distance);
}
.container[class*=start] {
  inset-inline-start: var(--calcite-internal-alert-edge-distance);
  inset-inline-end: auto;
}
.container[class*=end] {
  inset-inline-end: var(--calcite-internal-alert-edge-distance);
  inset-inline-start: auto;
}

.icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px;
  margin-block: auto;
  margin-inline-end: auto;
}

.close {
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: flex-end;
  align-self: stretch;
  border-style: none;
  background-color: transparent;
  color: var(--calcite-color-text-3);
  outline: 2px solid transparent;
  outline-offset: 2px;
  -webkit-appearance: none;
  border-start-end-radius: var(--calcite-alert-corner-radius, var(--calcite-border-radius));
  border-end-end-radius: var(--calcite-alert-corner-radius, var(--calcite-border-radius));
  outline-color: transparent;
}
.close:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          );
}
.close:hover, .close:focus {
  color: var(--calcite-color-text-1);
  background-color: var(--calcite-color-foreground-2);
}
.close:active {
  background-color: var(--calcite-color-foreground-3);
}

.queue-count {
  visibility: hidden;
  display: flex;
  min-inline-size: min-content;
  cursor: default;
  align-items: center;
  justify-content: space-around;
  align-self: stretch;
  overflow: hidden;
  text-align: center;
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-2);
  opacity: 0;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  border-inline: 0 solid transparent;
  border-start-end-radius: 0;
}
.queue-count--active {
  visibility: visible;
  opacity: 1;
}

.dismiss-progress {
  position: absolute;
  display: block;
  inline-size: 100%;
  overflow: hidden;
  inset-inline: 0;
  inset-block-start: -2px;
  block-size: 2px;
  border-radius: var(--calcite-border-radius) var(--calcite-border-radius) 0 0;
}
.dismiss-progress::after {
  position: absolute;
  inset-block-start: 0px;
  display: block;
  block-size: 2px;
  content: "";
  background-color: var(--calcite-color-transparent-tint);
  inset-inline-end: 0;
}

.actions-end {
  display: flex;
  align-self: stretch;
}

.text-container {
  box-sizing: border-box;
  display: flex;
  min-inline-size: 0px;
  flex: 1 1 auto;
  flex-direction: column;
  overflow-wrap: break-word;
}

.footer {
  position: relative;
  display: flex;
  inline-size: auto;
  justify-content: flex-end;
  align-self: stretch;
  padding-block-start: 1px;
  block-size: inherit;
}

:host([scale=s]) slot[name=title]::slotted(*),
:host([scale=s]) *::slotted([slot=title]) {
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
}
:host([scale=s]) slot[name=message]::slotted(*),
:host([scale=s]) *::slotted([slot=message]) {
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
}
:host([scale=s]) slot[name=link]::slotted(*),
:host([scale=s]) *::slotted([slot=link]) {
  font-size: var(--calcite-font-size--2);
  line-height: 1.375;
}
:host([scale=s]) .queue-count {
  margin-inline: 0.5rem;
}
:host([scale=s]) .container {
  --calcite-internal-alert-min-height: 3.5rem;
  inline-size: var(--calcite-alert-width, 40em);
}
:host([scale=s]) .close {
  padding: 0.75rem;
}
:host([scale=s]) .icon {
  padding-inline-start: 0.75rem;
}
:host([scale=s]) .text-container {
  padding-block: 0.5rem;
  padding-inline: 0.75rem 0.5rem;
}

:host([scale=m]) slot[name=title]::slotted(*),
:host([scale=m]) *::slotted([slot=title]) {
  font-size: var(--calcite-font-size-0);
  line-height: 1.375;
}
:host([scale=m]) slot[name=message]::slotted(*),
:host([scale=m]) *::slotted([slot=message]) {
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
}
:host([scale=m]) slot[name=link]::slotted(*),
:host([scale=m]) *::slotted([slot=link]) {
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
}
:host([scale=m]) .queue-count {
  margin-inline: 0.75rem;
}
:host([scale=m]) .container {
  --calcite-internal-alert-min-height: 4.1875rem;
  inline-size: var(--calcite-alert-width, 50em);
}
:host([scale=m]) .close {
  padding: 1rem;
}
:host([scale=m]) .icon {
  padding-inline-start: 1rem;
}
:host([scale=m]) .text-container {
  padding-block: 0.75rem;
  padding-inline: 1rem 0.75rem;
}

:host([scale=l]) slot[name=title]::slotted(*),
:host([scale=l]) *::slotted([slot=title]) {
  margin-block-end: 0.25rem;
  font-size: var(--calcite-font-size-1);
  line-height: 1.375;
}
:host([scale=l]) slot[name=message]::slotted(*),
:host([scale=l]) *::slotted([slot=message]) {
  font-size: var(--calcite-font-size-0);
  line-height: 1.375;
}
:host([scale=l]) slot[name=link]::slotted(*),
:host([scale=l]) *::slotted([slot=link]) {
  font-size: var(--calcite-font-size-0);
  line-height: 1.375;
}
:host([scale=l]) .queue-count {
  margin-inline: 1rem;
}
:host([scale=l]) .container {
  --calcite-internal-alert-min-height: 5.625rem;
  inline-size: var(--calcite-alert-width, 60em);
}
:host([scale=l]) .close {
  padding: 1.25rem;
}
:host([scale=l]) .icon {
  padding-inline-start: 1.25rem;
}
:host([scale=l]) .text-container {
  padding-block: 1rem;
  padding-inline: 1.25rem 1rem;
}

:host([open]) .container--active {
  border-block-start-width: 2px;
  opacity: 1;
  pointer-events: initial;
}
:host([open]) .container--active[class*=bottom] {
  transform: translate3d(0, calc(-1 * var(--calcite-internal-alert-edge-distance)), inherit);
}
:host([open]) .container--active[class*=top] {
  transform: translate3d(0, var(--calcite-internal-alert-edge-distance), inherit);
}

:host([auto-close]) > .queue-count {
  border-inline-end: 0 solid transparent;
}

slot[name=title]::slotted(*),
*::slotted([slot=title]) {
  font-size: var(--calcite-font-size-0);
  line-height: 1.375;
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1);
}

slot[name=message]::slotted(*),
*::slotted([slot=message]) {
  margin: 0px;
  display: inline;
  font-size: var(--calcite-font-size--1);
  line-height: 1.375;
  font-weight: var(--calcite-font-weight-normal);
  margin-inline-end: 0.5rem;
  color: var(--calcite-color-text-2);
}

slot[name=link]::slotted(*),
*::slotted([slot=link]) {
  display: inline-flex;
  color: var(--calcite-color-text-link);
}

:host([kind=brand]) .container {
  border-block-start-color: var(--calcite-color-brand);
}
:host([kind=brand]) .container .icon {
  color: var(--calcite-color-brand);
}

:host([kind=info]) .container {
  border-block-start-color: var(--calcite-color-status-info);
}
:host([kind=info]) .container .icon {
  color: var(--calcite-color-status-info);
}

:host([kind=danger]) .container {
  border-block-start-color: var(--calcite-color-status-danger);
}
:host([kind=danger]) .container .icon {
  color: var(--calcite-color-status-danger);
}

:host([kind=success]) .container {
  border-block-start-color: var(--calcite-color-status-success);
}
:host([kind=success]) .container .icon {
  color: var(--calcite-color-status-success);
}

:host([kind=warning]) .container {
  border-block-start-color: var(--calcite-color-status-warning);
}
:host([kind=warning]) .container .icon {
  color: var(--calcite-color-status-warning);
}

:host([auto-close-duration=fast]) .dismiss-progress:after {
  animation: dismissProgress 6000ms ease-out;
}

:host(:hover[auto-close-duration=fast]) .dismiss-progress:after,
:host(:focus[auto-close-duration=fast]) .dismiss-progress:after {
  animation-play-state: paused;
}

:host([auto-close-duration=medium]) .dismiss-progress:after {
  animation: dismissProgress 10000ms ease-out;
}

:host(:hover[auto-close-duration=medium]) .dismiss-progress:after,
:host(:focus[auto-close-duration=medium]) .dismiss-progress:after {
  animation-play-state: paused;
}

:host([auto-close-duration=slow]) .dismiss-progress:after {
  animation: dismissProgress 14000ms ease-out;
}

:host(:hover[auto-close-duration=slow]) .dismiss-progress:after,
:host(:focus[auto-close-duration=slow]) .dismiss-progress:after {
  animation-play-state: paused;
}

.container.focused .dismiss-progress::after {
  animation-play-state: paused;
}

@keyframes dismissProgress {
  0% {
    inline-size: 0px;
    opacity: 0.75;
  }
  100% {
    inline-size: 100%;
    opacity: 1;
  }
}
/**
 * Conditional styles for when Alert is slotted in Shell
 */
.container--embedded {
  position: absolute;
}

:host([hidden]) {
  display: none;
}

[hidden] {
  display: none;
}

:host([calcite-hydrated-hidden]) {
  visibility: hidden !important;
  pointer-events: none;
}